// queries.js

import { gql } from "@apollo/client";

export const GET_NUMBER_CHANNEL_CHOICES = gql`
  query numberChannels {
    numberChannels
  }
`;
